import type { JSX } from "react";
import ExclamationCircle from "@repo/icons/default/ExclamationCircle";
import { useRouter } from "@tanstack/react-router";
import type { UseQueryResult } from "@tanstack/react-query";
import {
  EmptyStateButton,
  EmptyStateDescription,
  EmptyStateIcon,
  EmptyStateRoot,
  EmptyStateTitle,
} from "@/components/ui/empty-state/empty-state";
import { FullPageSpinner } from "@/components/ui/loading/full-page-spinner";

type AsyncDataWrapperProps = UseQueryResult & {
  children: React.ReactNode;
  fallback?: JSX.Element;
  errorFallback?: JSX.Element;
};

const ErrorEmptyState = (): JSX.Element => {
  const router = useRouter();
  const reloadPage = (): void => router.history.go(0);

  return (
    <EmptyStateRoot>
      <EmptyStateIcon icon={ExclamationCircle} fill="danger" />
      <EmptyStateTitle>Ocorreu um erro</EmptyStateTitle>
      <EmptyStateDescription>
        Parece que ocorreu um erro ao tentar realizar esta ação. Por favor, tente
        novamente ou recarregue a página.
      </EmptyStateDescription>

      <EmptyStateButton onClick={reloadPage} fullWidth>
        Tentar novamente
      </EmptyStateButton>
    </EmptyStateRoot>
  );
};

export const AsyncDataWrapper = ({
  isPending,
  isError,
  children,
  fallback = <FullPageSpinner />,
  errorFallback = <ErrorEmptyState />,
}: AsyncDataWrapperProps): JSX.Element => {
  if (isPending) {
    return fallback;
  }

  if (isError) {
    return errorFallback;
  }

  return <>{children}</>;
};
